import DpButtonTheme from '@/libs/components/DpUiComponents/DpButtonTheme'
import { Button } from 'antd-mobile'

type PropsType = {
  style?: React.CSSProperties
  onClick?: Function | undefined
  type?: string
  disabled?: boolean
  isTheme?: boolean
  buttonText?: string | React.ReactNode
  className?: any
  btnProps?: any
}

const DpButtonThemeConfig = (props: PropsType) => {
  const { type, isTheme, btnProps, buttonText, ...resProps } = props
  if (isTheme) {
    return (
      <DpButtonTheme
        type={type}
        {...resProps}
        onClick={props?.onClick}
      >
        {buttonText}
      </DpButtonTheme>
    )
  }
  return (
    <Button
      block={true}
      type="submit"
      color="primary"
      size="middle"
      {...resProps}
      {...btnProps}
    >
      {buttonText}
    </Button>
  )
}

export default DpButtonThemeConfig
